module.exports = __webpack_public_path__ + "img/timebinder-icon-calendar.88b0972b.svg";